import React from 'react';
import './Process.css';

const steps = [
  { num: '01', title: 'Discovery', desc: 'We dive deep into your brand, audience, and competitive landscape to uncover what makes you unique.' },
  { num: '02', title: 'Strategy', desc: 'We craft a tailored roadmap with clear KPIs, channel mix, and creative direction.' },
  { num: '03', title: 'Execution', desc: 'Our team brings the strategy to life with precision — from content to campaigns to conversions.' },
  { num: '04', title: 'Optimise', desc: 'We analyse, iterate, and scale what works — constantly improving your results.' },
];
 
export default function Process() {
  return (
    <section className="process" id="process">
      <div className="process__left">
        <span className="label">Our Process</span>
        <h2>How We <br /><em>Make Magic</em></h2>
        <p className="process__desc">
          We don't believe in cookie-cutter campaigns. Every project starts with deep discovery and ends with measurable results that move your business forward.
        </p>
        <a href="#contact" className="btn btn--primary">Work With Us</a>
      </div>

      <div className="process__steps">
        {steps.map((step) => (
          <div className="step" key={step.num}>
            <span className="step__num">{step.num}</span>
            <div className="step__body">
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}